import { IntlShape } from 'react-intl';
import * as yup from 'yup';

export const editModeValidationSchema = (intl: IntlShape) =>
  yup.object().shape({
    uiEditValues: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.string().required(
            intl.formatMessage({
              id: 'features.queueSettings.editMode.editValues.id.required',
            })
          ),
          label: yup.string().required(
            intl.formatMessage({
              id: 'features.queueSettings.editMode.editValues.label.required',
            })
          ),
          dataType: yup.string().oneOf(['string', 'enum']).required(),
          enumOptions: yup.array().when('dataType', {
            is: 'enum',
            then: schema =>
              schema
                .of(
                  yup.object().shape({
                    label: yup.string().required(
                      intl.formatMessage({
                        id: 'features.queueSettings.editMode.editValues.option.label.required',
                      })
                    ),
                    value: yup.string().required(
                      intl.formatMessage({
                        id: 'features.queueSettings.editMode.editValues.option.value.required',
                      })
                    ),
                  })
                )
                .min(
                  1,
                  intl.formatMessage({
                    id: 'features.queueSettings.editMode.editValues.options.min',
                  })
                ),
            otherwise: schema => schema,
          }),
        })
      )
      .test('unique-id', function uniqueId(list) {
        const items = list ?? [];
        const seen = new Set<string>();

        for (let index = 0; index < items.length; index += 1) {
          const id = items[index]?.id;

          if (id) {
            if (seen.has(id)) {
              return this.createError({
                path: `uiEditValues[${index}].id`,
                message: intl.formatMessage({
                  id: 'features.queueSettings.editMode.editValues.id.unique',
                }),
              });
            }
            seen.add(id);
          }
        }

        return true;
      }),
    uiEditTargetQueueSelectionEnabled: yup.boolean(),
    uiEditAlwaysSplitDocument: yup.boolean(),
    uiOnEditConfirm: yup
      .string()
      .oneOf(['annotation_list', 'edit_next', 'validate_first']),
    uiValidationScreenEnabled: yup.boolean(),
  });
